"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";

export function SentryInit() {
  useEffect(() => {
    // Check if Sentry is already initialized
    const client = Sentry.getCurrentHub().getClient();
    const existingDsn = client?.getDsn();
    
    if (existingDsn) {
      return;
    }

    // If not initialized, initialize it manually
    const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN || "https://6e925fbe88274e9db238a832fd50b562@status.agentsystems.co.uk/6";
    
    try {
      Sentry.init({
        dsn: dsn,
        tracesSampleRate: 0.1,
        debug: process.env.NODE_ENV === "development",
        tunnel: "/api/glitchtip-tunnel",
        environment: process.env.NODE_ENV || "development",
      });
    } catch (error) {
      // Silently fail - Sentry initialization errors shouldn't break the app
    }
  }, []);

  return null; // This component doesn't render anything
}

